import { render } from "./EmailVerified.vue?vue&type=template&id=f8ef4918&scoped=true"
import script from "./EmailVerified.vue?vue&type=script&lang=js"
export * from "./EmailVerified.vue?vue&type=script&lang=js"

import "./EmailVerified.vue?vue&type=style&index=0&id=f8ef4918&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8ef4918"]])

export default __exports__